import { gql } from '@apollo/client';

export const decisionDefinitionModel = gql`
  query decisionDefinitionModel($id: ID!, $decisionDefinitionKey: String!) {
    decisionDefinitionModel(id: $id, decisionDefinitionKey: $decisionDefinitionKey)
  }
`;

export const ruleHistory = gql`
  query ruleHistory(
    $id: ID!
    $decisionDefinitionKey: String!
    $pageNumber: Int!
    $pageSize: Int!
    $sortBy: String!
    $sortOrder: SortOrder!
  ) {
    ruleHistory(
      input: {
        id: $id
        decisionDefinitionKey: $decisionDefinitionKey
        pageNumber: $pageNumber
        pageSize: $pageSize
        sortBy: $sortBy
        sortOrder: $sortOrder
      }
    ) {
      totalElements
      decisionChangeSummaries {
        auditId
        decisiondefinitionId
        decisionDefinitionKey
        version
        oldValue
        newValue
        message
        updatedBy
        updatedDateTime
        fullName
      }
    }
  }
`;

export const decisionDefinitionList = gql`
  query decisionDefinitionList($id: ID!) {
    decisionDefinitionList(id: $id) {
      decisionDefinition {
        id
        key
        name
      }
      ssamContainer
    }
  }
`;

export const deployDecisionModel = gql`
  mutation deployDecisionModel($id: ID!, $decisionDefinitionKey: String!, $xml: String) {
    deployDecisionModel(id: $id, decisionDefinitionKey: $decisionDefinitionKey, xml: $xml) {
      id
      name
    }
  }
`;
